import { showToastWithTimeout } from "../../store/actions/message";

/**
 * Wraps a file-download action and shows a toast confirming the download.
 * Use for any code path that triggers a browser download.
 *
 * @param filename — full filename (including extension) shown to the user in the toast
 * @param action — function that triggers the download; may be sync or async
 */
export async function withDownloadToast<T>(
  filename: string,
  action: () => T | Promise<T>
): Promise<T> {
  try {
    const result = await action();
    showToastWithTimeout(`Downloading ${filename}`, "success");
    return result;
  } catch (error) {
    showToastWithTimeout(`Failed to download ${filename}`, "danger");
    throw error;
  }
}
